import createVueApp from '@phoenix/createVueApp';
import MovementGrid from '@maison/components/movement/MovementGrid.vue';

document.querySelectorAll('.phoenix-movement-grid').forEach((element: Element) => {
  const movementGrid = createVueApp({}, true);
  movementGrid.component('MovementGrid', MovementGrid);
  movementGrid.mount(element);
});
